<script>
import {defineComponent} from "vue";
//import PlayButton from "@/components/buttons/PlayButton.vue";
import AnimatedRegion from "@/components/block/elements/AnimatedRegion.vue";
import {mapGetters} from "vuex";
import {ACTION_TYPE_ANIMATE} from "@/components/graphics/Graphics";
//import AdvImageElement from "@/components/graphics/AdvImageElement.vue";

export default defineComponent({
	name: "ProductRegion",
	props: {
		product: {
			type: Object,
			default: () => {
				return {};
			}
		},
		region: {
			type: Object,
			default: () => {
				return {};
			}
		}
	},
	computed: {
		...mapGetters(['productsBySKU']),
		isClickable() {
			if (this.product?.disableClickRegions) return false;
			if (ACTION_TYPE_ANIMATE.includes(this.actionType)) {
				return !!this.productsBySKU[this.sku];
			}
			return true;
		},
		sku() {
			return (this.product.sku || "").toUpperCase().replace(`${this.actionType.toUpperCase()}|`, '').split('|')?.[0].trim();
		},
		isPlayButton() {
			return this.actionType.toLowerCase().includes('play');
		},
		isAnimated() {
			return ACTION_TYPE_ANIMATE.includes(this.actionType);
		},
		isInBlockVideo() {
			return this.actionType.toLowerCase().includes("inblock");
		},
		actionType() {
			return (this.product.actionType || this.product.sku || '').trim();
    },
     comp() {
			if (this.isPlayButton) return "img";// PlayButton;
			if (this.isAnimated) return AnimatedRegion;
			if (this.product?.inblockControls && this.isInBlockVideo) {
				//showing playbutton for inblock Video
				return "img";
			}
			return "div";
		},
		props() {
			if (this.isAnimated) {
				return {
					product: this.product,
					region: this.region
				}
			} else {
				return {
					src: '/images/play_button.svg'
				}
			}
		}
	},
	methods: {
		onClick() {
			console.log('click', this.product, this.region);
		}
	}
});
</script>

<template>
	<component :is="comp" :class="'product-region-item' + (isClickable ? ' clickable' : ' no-click') + (isPlayButton ? ' front' : '')" v-bind="props"/>
</template>

<style lang="scss" scoped>
.product-region-item {
  width: 100%;
  height: 100%;

  &.no-click {
	pointer-events: none;
  }

  &.clickable {
	cursor: pointer;
      pointer-events: inherit;
  }
}
</style>
